import { decodeHexResponse } from '../_common/common.utils';
import LeaveReasonMasterActionTypes from './LeaveReasonMaster.types';

const INITIAL_STATE = {
	leaveReasonMasterData: null,
	updateLeaveReasonMasterData: null,
	addLeaveReasonMasterData: null,
	error: null,
};

interface LeaveReasonMasterState {
	leaveReasonMasterData: any;
	updateLeaveReasonMasterData: any;
	addLeaveReasonMasterData: any;
	error: any;
}

interface LeaveReasonMasterAction {
	type: string;
	payload: any;
}

const leaveReasonMasterReducer = (
	state = INITIAL_STATE,
	action: LeaveReasonMasterAction,
): LeaveReasonMasterState => {
	switch (action.type) {
		case LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_START:
			return { ...state, leaveReasonMasterData: null };
		case LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_SUCCESS:
			return {
				...state,
				leaveReasonMasterData: action.payload?.response
					? decodeHexResponse(
							action.payload,
							LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_KEY,
					  )
					: action.payload,
			};
		case LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_FAILURE:
			return {
				...state,
				leaveReasonMasterData: action.payload?.response
					? decodeHexResponse(
							action.payload,
							LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_KEY,
					  )
					: action.payload,
			};
		case LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_RESPONSE_CHANGED:
			return { ...state, leaveReasonMasterData: null };
		case LeaveReasonMasterActionTypes.LEAVE_REASON_MASTER_RESPONSE_REST_START:
			return { ...state, leaveReasonMasterData: null };
		case LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_START:
			return { ...state, updateLeaveReasonMasterData: null };
		case LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_SUCCESS:
			return {
				...state,
				updateLeaveReasonMasterData: action.payload?.response
					? decodeHexResponse(
							action.payload,
							LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_KEY,
					  )
					: action.payload,
			};
		case LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_FAILURE:
			return {
				...state,
				updateLeaveReasonMasterData: action.payload?.response
					? decodeHexResponse(
							action.payload,
							LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_KEY,
					  )
					: action.payload,
			};
		case LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_START:
			return { ...state, updateLeaveReasonMasterData: null };
		case LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS:
			return { ...state, updateLeaveReasonMasterData: action.payload };
		case LeaveReasonMasterActionTypes.UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_FAILURE:
			return { ...state, updateLeaveReasonMasterData: action.payload };
		case LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_START:
			return { ...state, addLeaveReasonMasterData: null };
		case LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_SUCCESS:
			return {
				...state,
				addLeaveReasonMasterData: action.payload?.response
					? decodeHexResponse(
							action.payload,
							LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_KEY,
					  )
					: action.payload,
			};
		case LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_FAILURE:
			return {
				...state,
				addLeaveReasonMasterData: action.payload?.response
					? decodeHexResponse(
							action.payload,
							LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_KEY,
					  )
					: action.payload,
			};
		case LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_RESPONSE_REST_START:
			return { ...state, addLeaveReasonMasterData: null };
		case LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS:
			return { ...state, addLeaveReasonMasterData: action.payload };
		case LeaveReasonMasterActionTypes.ADD_LEAVE_REASON_MASTER_RESPONSE_REST_FAILURE:
			return { ...state, addLeaveReasonMasterData: action.payload };
		default:
			return state;
	}
};

export default leaveReasonMasterReducer;
